import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/utils/analytics';

/**
 * Reports each client-side navigation to the analytics counters. Only the
 * pathname is sent: query strings carry one-time tokens (verify/reset links).
 */
export function RouteTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);

  return null;
}
